import { oneOfType, number, string, oneOf } from 'prop-types'
import Conditional from '../../Conditional'
import { kuiperClassNames, renderIcon } from '../../utils'

import './styles.scss'

const PillV2 = ({
  bgColor = 'n4',
  content = ' ',
  fgColor = 'n3',
  icon,
  size = 'small',
}) => (
  <div
    className={kuiperClassNames(
      'pillV2',
      `fg-color-${fgColor}`,
      `bg-color-${bgColor}`,
      size
    )}
  >
    <Conditional condition={icon}>
      {renderIcon(icon, { ariaMode: 'hidden' })}
    </Conditional>
    <span>{content}</span>
  </div>
)

PillV2.propTypes = {
  bgColor: string,
  content: oneOfType([number, string]),
  fgColor: string,
  icon: string,
  size: oneOf(['small', 'large']),
}

export default PillV2
